import { render, staticRenderFns } from "./windowBeneficioComplemetarioComponent.vue?vue&type=template&id=3e4973fa&scoped=true&"
import script from "./windowBeneficioComplemetarioComponent.vue?vue&type=script&lang=js&"
export * from "./windowBeneficioComplemetarioComponent.vue?vue&type=script&lang=js&"
import style0 from "./windowBeneficioComplemetarioComponent.vue?vue&type=style&index=0&id=3e4973fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4973fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VCol,VContainer,VIcon,VImg,VRadio,VRadioGroup,VRow,VTooltip})
